var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BDropdownItem',{attrs:{"href":"#","disabled":_vm.isProcessing},on:{"click":function($event){$event.preventDefault();return _vm.process.apply(null, arguments)}}},[_c('i',{staticClass:"fad fa-repeat mr-3 text-warning"}),_vm._v("Obnovit zakázku do "),_c('strong',[_vm._v("Naplánováno")])])
}
var staticRenderFns = []

export { render, staticRenderFns }